import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRoomsApi, roomJoinApi, roomLeaveApi } from "../helpers/axios";

export const getRooms = createAsyncThunk("getRooms", async () => {
  try {
    const response = await getRoomsApi();
    return response;
  } catch (error) {
    window.location.href = process.env.REACT_APP_WORLDSINGLES_APP_URL;
    throw new Error(error);
  }
});

export const roomJoin = createAsyncThunk("roomJoin", async (room_id) => {
  try {
    const response = await roomJoinApi(room_id);
    return response;
  } catch (error) {
    throw new Error(error);
  }
});

export const roomLeave = createAsyncThunk(
  "roomLeave",
  async ({ roomId, userId }) => {
    try {
      const response = await roomLeaveApi(roomId, userId);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  }
);

const initialState = {
  rooms: [],
  loading: false,
  loaded: false,
  loadingLeave: false,
  error: null,
};

export const roomSlice = createSlice({
  name: "rooms",
  initialState,
  reducers: {
    updateRoom(state, action) {
      const updatedRoom = action.payload;
      const index = state.rooms.findIndex(
        (room) => room.id === parseInt(updatedRoom.id)
      );
      if (index !== -1) {
        state.rooms[index] = updatedRoom;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRooms.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRooms.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload?.rooms;
        state.loaded = true;
      })
      .addCase(getRooms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      })
      .addCase(roomJoin.pending, (state) => {
        state.loading = true;
      })
      .addCase(roomJoin.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(roomJoin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      })
      .addCase(roomLeave.pending, (state) => {
        state.loadingLeave = true;
      })
      .addCase(roomLeave.fulfilled, (state, action) => {
        state.loadingLeave = false;
      })
      .addCase(roomLeave.rejected, (state, action) => {
        state.loadingLeave = false;
        state.error = action.error;
      });
  },
});

export const { updateRoom } = roomSlice.actions;
export default roomSlice.reducer;
